<template>
  <v-card>
    <div class="pt-2">
      <v-card flat>
        <v-row class="d-flex justify-space-between padding-bottom">
          <div>
            <v-btn
              depressed
              color="primary"
              v-on:click="back()"
            >
              返回
            </v-btn>
          </div>
        </v-row>
        <v-row class="mt-3">
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tab
              v-for="item in items"
              :key="item.tab"
              :href="'#tab-' + item.tab"
            >
              {{ item.tab }}
            </v-tab>
          </v-tabs>
          <!--内容-->
          <v-tabs-items v-model="tab">
            <v-tab-item
              v-for="it in items"
              :key="it.tab"
              :value="'tab-' + it.tab"
            >
              <v-simple-table
                fixed-header
                height="750px"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        事项编号
                      </th>
                      <th class="text-left">
                        所属科目
                      </th>
                      <th class="text-left">
                        事项类别
                      </th>
                      <th class="text-left">
                        业务事项
                      </th>
                      <th class="text-left">
                        自维/外委
                      </th>
                      <th class="text-left">
                        预算费用组成
                      </th>
                      <th class="text-left">
                        单价来源
                      </th>
                      <th class="text-left">
                        标准次数
                      </th>
                      <th class="text-left">
                        周期
                      </th>
                      <th class="text-center">
                        业务实施录入
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="infoMap[it.id]&&infoMap[it.id].length>0">
                      <template v-for="(item,index) in infoMap[it.id]">
                        <tr>
                          <td>{{item.matterId}}</td>
                          <td v-if="index==0||(index>0&&item.subjectName!=infoMap[it.id][index-1].subjectName)"
                            :rowspan="_calcRowSpan(index,infoMap[it.id],'subjectName')">{{item.subjectName}}</td>
                          <td v-if="index==0||(index>0&&item.typeName!=infoMap[it.id][index-1].typeName)"
                            :rowspan="_calcRowSpan(index,infoMap[it.id],'typeName')">{{item.typeName}}</td>
                          <td>{{item.matterName}}</td>
                          <td>{{item.repairType==1?'自维':'外委'}}</td>
                          <td>{{item.budgetDesc}}</td>
                          <td>{{item.priceSource}}</td>
                          <td>{{item.times}}</td>
                          <td>{{item.cycle}}年</td>
                          <td>
                            <v-btn text :color="item.isDone==1?'error':'primary'" :disabled="!_hasButtonPermission('实施处理')" block small @click="enterShow(item)">{{item.isDone==1?'已录入':'录入'}}</v-btn>
                          </td>
                        </tr>
                      </template>
                    </template>
                    <template v-else>
                      <tr class="v-data-table__empty-wrapper">
                        <td colspan="10">没有数据</td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-tab-item>
          </v-tabs-items>
        </v-row>
      </v-card>
    </div>
    <!--弹窗-->
    <v-dialog
      v-model="enterDialog"
      width="600"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          录入金额<label class="red--text">（根据合同付款金额录入，不含税）</label>
        </v-card-title>
        <v-card-text>
          <v-container class="mt-5">
            <v-row dense>
              <v-col cols="12" sm="4" style="text-align: right">
                <label>预算金额：</label>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="chooseItem.budgetFee"
                  dense
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4" style="text-align: right">
                <label>实际使用金额：</label>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="inputValue"
                  dense
                  outlined
                  v-on:change="_bindNumInput"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="btnDisabled" text @click="handleEnter"> 确定 </v-btn>
          <v-btn text @click="enterHide"> 取消 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { default as BudgetCostApi } from "@/api/pd/budget/BudgetCostApi.js";
export default {
  props: {
    id: [Number, String],
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      tab: null,
      items: [
        { tab: "一月", id: 1 },
        { tab: "二月", id: 2 },
        { tab: "三月", id: 3 },
        { tab: "四月", id: 4 },
        { tab: "五月", id: 5 },
        { tab: "六月", id: 6 },
        { tab: "七月", id: 7 },
        { tab: "八月", id: 8 },
        { tab: "九月", id: 9 },
        { tab: "十月", id: 10 },
        { tab: "十一月", id: 11 },
        { tab: "十二月", id: 12 },
      ],
      btnDisabled: false,
      infoMap: {},
      chooseItem: {},
      enterDialog: false,
      inputValue: null
    };
  },
  mounted(){
    // 默认取1
	  this.getDataFromApi();
  },
  methods:{
    back(){
      this.$emit("back")
    },
    async getDataFromApi() {
      let me = this;
      let queryUserResp = await BudgetCostApi.listImplement({
        costId: me.id
      });
      console.log("load user returned;");
      console.log(queryUserResp);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取预算实施列表失败" : msg;
        throw new Error(msg);
      }
      if (!data.data) {
        throw new Error("获取预算实施列表情况失败(无会话数据)");
      }
      me.infoMap = data.data;
    },
    enterShow(item){
      this.chooseItem = item
      this.enterDialog = true
      if(this.chooseItem.actualFee||this.chooseItem.actualFee==0){
        this.inputValue = this.chooseItem.actualFee
      } else {
        this.inputValue = null
      }
    },
    async handleEnter(){
      if(!this.inputValue&&this.inputValue!=0){
        this.$dialog.error({
          title:'错误',
          text:'请填写实际使用金额'
        })
        return
      }
      let me = this;
      me.btnDisabled = true
      let res = await BudgetCostApi.implementEnter({
        costId: me.chooseItem.costId,
        matterId: me.chooseItem.matterId,
        month: me.chooseItem.month,
        actualFee: me.inputValue
      });
      if (res.data.code === 200) {
        me.$dialog.info({
          text: res.data.msg,
          title: "操作成功",
        });
        me.enterHide()
        me.getDataFromApi()
      } else {
        me.$dialog.error({
          text: res.data.msg_detail,
          title: res.data.msg,
        });
      }
      me.btnDisabled = false
    },
    enterHide(){
      this.chooseItem = {}
      this.enterDialog = false
      this.inputValue = null
    },
    _hasButtonPermission(name){
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton =false
      for(let i=0;i<buttonPriviledgeList.length;i++){
        if(buttonPriviledgeList[i].name==name){
          if(buttonPriviledgeList[i].hasPriviledge=='Y'){
            return true
          } else {
            return false
          }
        }
      }
      return false
    },
    _calcRowSpan(index,items,title){
      let name = items[index][title]
      let num = 0
      for(let i=index;i<items.length;i++){
        if(name!==items[i][title]){
          break
        }
        num++
      }
      return num
    },
    _bindNumInput(){
      let value = this.inputValue.replace(/[^\d.]/g,'') || 0
      value = Number(value)
      if(value<0){
        value = 0
      }
      this.inputValue = value
    },
  }
};
</script>
<style scoped>
.container{
  padding: 0;
}
.row{
  margin: 0;
}
.padding-bottom{
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}
.padding-top{
  padding-top: 30px;
}
.margin-right{
  margin-right: 12px;
}
.v-application p{
  margin-bottom: 0;
}
</style>